<template>
    <div class="system-modal flex-container" @click.self="$emit('close')">
        <div class="modal-content vertical" style="width: 280px;">
            <div class="modal-header">
                <p v-if="title != undefined" class="title"> {{ `${$t('Status')} ${activeObject.systemName} (${activeDay == 0 ? $t('today') : activeDay + ' ' + $t('daysAgo')})`}} </p>
                <div id="mdiv" @click="$emit('close')">
                    <div class="mdiv">
                        <div class="md"></div>
                    </div>
                </div>
            </div>
            <div class="modal-slot vertical">
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px;"> {{ $t('BlackBox') }} </div>
                    <div>
                        <img v-if="blackBox == 0" src="@/assets/img/Systems/Status/Ok.svg"/>
                        <img v-else-if="blackBox == 1" src="@/assets/img/Systems/Status/Warning.svg"/>
                        <img v-else-if="blackBox == 2" src="@/assets/img/Systems/Status/Error.svg"/>
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px;">{{ $t('Device') }}</div>
                    <div>
                        <img v-if="device == 0" src="@/assets/img/Systems/Status/Ok.svg"/>
                        <img v-else-if="device == 1" src="@/assets/img/Systems/Status/Warning.svg"/>
                        <img v-else-if="device == 2" src="@/assets/img/Systems/Status/Error.svg"/>
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px;">{{ $t('Rapid24h') }}</div>
                    <div>
                        <img v-if="rapid24 == 0" src="@/assets/img/Systems/Status/Ok.svg"/>
                        <img v-else-if="rapid24 == 1" src="@/assets/img/Systems/Status/Warning.svg"/>
                        <img v-else-if="rapid24 == 2" src="@/assets/img/Systems/Status/Error.svg"/>
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px;">{{ $t('Photocells') }}</div>
                    <div>
                        <img v-if="photocells == 0" src="@/assets/img/Systems/Status/Ok.svg"/>
                        <img v-else-if="photocells == 1" src="@/assets/img/Systems/Status/Warning.svg"/>
                        <img v-else-if="photocells == 2" src="@/assets/img/Systems/Status/Error.svg"/>
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px;">{{ $t('Pressure') }}</div>
                    <div>
                        <img v-if="pressure == 0" src="@/assets/img/Systems/Status/Ok.svg"/>
                        <img v-else-if="pressure == 1" src="@/assets/img/Systems/Status/Warning.svg"/>
                        <img v-else-if="pressure == 2" src="@/assets/img/Systems/Status/Error.svg"/>
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px;">{{ $t('Database') }}</div>
                    <div>
                        <img v-if="database == 0" src="@/assets/img/Systems/Status/Ok.svg"/>
                        <img v-else-if="database == 1" src="@/assets/img/Systems/Status/Warning.svg"/>
                        <img v-else-if="database == 2" src="@/assets/img/Systems/Status/Error.svg"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from '@/components/Modal'

export default {
    components: {
        Modal,
    },
    props: {
        activeObject: {

        },
        activeDay: {

        },
        title: {
            type: String,
            required: false,
            default: "Status (" + this.activeDay + " days ago)"
        }
    },
    data() {
        return {
            general: 0,
            blackBox: 0,
            device: 0,
            rapid24: 0,
            photocells: 0,
            pressure: 0,
            database: 0
        }
    },
    methods: {
        computeData() {
            var index = this.activeDay;
            this.general = this.activeObject.statusTab[index][1];
            this.blackBox = this.activeObject.statusTab[index][2];
            this.device = this.activeObject.statusTab[index][3];
            this.rapid24 = this.activeObject.statusTab[index][4];
            this.photocells = this.activeObject.statusTab[index][5];
            this.pressure = this.activeObject.statusTab[index][6];
            this.database = this.activeObject.statusTab[index][7];
        }
    },
    mounted() {
        this.computeData()
    }
}
</script>

<style scoped>
.system-modal {
    z-index: 999;
    display: block;
}

.modal-header {
    background-color:  #34758E;
    width: 100%;
    font-family: "SourceSansProBold", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    color: white;
}

.title {
    width: 200px;
    font-family: 'SourceSansProSemiBold', sans-serif !important;
    font-weight: bold;
    font-size: 14px;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/TooltipSystemStatus.vue